// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faqs_faqs__HZIAb","grid":"faqs_grid__CiYBK","phAnimation":"faqs_phAnimation__mClEt"};